import { getData } from '../axiosServices'

export const coderDistributionAdmin = async (coeID,labType) => {
    const url = `reports/coe/${coeID}/labtype/${labType}/admin`;
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
    }

    return getData(url,  { headers });
};


export const coderDistributionMentor = (coeID,labType) => {
    const url = `reports/coe/${coeID}/labtype/${labType}`;
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
    };
    return getData(url,  { headers });
}
